import { render, staticRenderFns } from "./ShoBloodTransfusions.vue?vue&type=template&id=07190430&scoped=true"
import script from "./ShoBloodTransfusions.vue?vue&type=script&lang=js"
export * from "./ShoBloodTransfusions.vue?vue&type=script&lang=js"
import style0 from "./ShoBloodTransfusions.vue?vue&type=style&index=0&id=07190430&prod&lang=scss&scoped=true"
import style1 from "./ShoBloodTransfusions.vue?vue&type=style&index=1&id=07190430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07190430",
  null
  
)

export default component.exports